module.exports = __webpack_public_path__ + "static/media/open-graph.7b5c9a3b.webp";